// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-wrap {
  background: var(--white);
  padding: 3rem 2rem 4rem;
  border-radius: 0.8rem;
  display: grid;
}
.table-wrap > .header {
  margin-bottom: 2rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 4rem;
  align-items: center;
}
.table-wrap > .header > div:nth-child(even) {
  justify-self: flex-end;
}
.table-wrap > .header > .title {
  font-size: 2rem;
  line-height: 2.4rem;
  color: var(--black);
  padding-left: 1rem;
}
.table-wrap > .header .exports {
  display: flex;
  gap: 1rem;
}
.table-wrap > .header .exports .btn {
  position: relative;
}
.table-wrap > .header .exports .btn .title {
  display: none;
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: var(--white);
  white-space: nowrap;
  background: var(--grey-icon);
  padding: 0.5rem 1rem;
  border-radius: 0.4rem;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 100%);
}
.table-wrap > .header .exports .btn i {
  font-size: 2.4rem;
  cursor: pointer;
}
.table-wrap > .header .exports .btn i:before {
  color: var(--grey-icon);
  transition: color 0.3s;
}
.table-wrap > .header .exports .btn:hover .title {
  display: block;
}
.table-wrap > .header .exports .btn:hover i:before {
  color: var(--primary);
}
.table-wrap > .header .nav {
  display: flex;
  align-items: center;
  gap: 4rem;
}
.table-wrap > .header .nav .tabs {
  display: flex;
  gap: 1rem;
}
.table-wrap > .header .nav .tabs .tab {
  height: 2.4rem;
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: var(--black);
  background: var(--bg);
  padding: 0 1.5rem;
  border-radius: 3rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: color 0.2s, background 0.2s;
}
.table-wrap > .header .nav .tabs .tab.active {
  color: var(--white);
  background: var(--primary);
}
.table-wrap > .header .nav .pagination {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.table-wrap > .header .nav .pagination .btn {
  width: 2.4rem;
  height: 2.4rem;
  font-size: 1.2rem;
  color: var(--grey);
  border: 0.1rem solid var(--grey-variable-hover);
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s;
}
.table-wrap > .header .nav .pagination .btn:hover {
  border-color: var(--primary-30);
}
.table-wrap > .header .nav .pagination .btn:active {
  border-color: var(--primary);
}
.table-wrap > .header .nav .pagination .btn:disabled {
  border: 0.1rem solid var(--grey-variable-hover);
  opacity: 0.5;
  cursor: default;
}
.table-wrap > .header .nav .pagination .btn.prev {
  transform: rotateZ(90deg);
}
.table-wrap > .header .nav .pagination .btn.next {
  transform: rotateZ(-90deg);
}
.table-wrap > .header .nav .pagination .current {
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: var(--grey-icon);
}
.table-wrap > .header .action {
  display: flex;
  align-items: center;
  gap: 3rem;
}
.table-wrap > .header .action .currency {
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: var(--grey-icon);
  display: flex;
  align-items: center;
}
.table-wrap > .header .action .currency .divider {
  width: 0.1rem;
  height: 1.4rem;
  background: var(--grey-icon);
  display: inline-block;
  margin: 0 1rem;
}
.table-wrap > .header .action .add {
  font-size: 2.4rem;
  color: var(--primary);
}

.scroll {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/shared/tables/table-wrap/table-wrap.component.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,uBAAA;EACA,qBAAA;EACA,aAAA;AACF;AACE;EACE,mBAAA;EACA,aAAA;EACA,qCAAA;EACA,cAAA;EACA,mBAAA;AACJ;AACI;EACE,sBAAA;AACN;AAEI;EACE,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAAN;AAGI;EACE,aAAA;EACA,SAAA;AADN;AAGM;EACE,kBAAA;AADR;AAGQ;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,gCAAA;AADV;AAIQ;EACE,iBAAA;EACA,eAAA;AAFV;AAIU;EACE,uBAAA;EACA,sBAAA;AAFZ;AAOU;EACE,cAAA;AALZ;AAQU;EACE,qBAAA;AANZ;AAYI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAVN;AAYM;EACE,aAAA;EACA,SAAA;AAVR;AAYQ;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uCACE;AAXZ;AAcU;EACE,mBAAA;EACA,0BAAA;AAZZ;AAiBM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAfR;AAiBQ;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,+CAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AAfV;AAiBU;EACE,+BAAA;AAfZ;AAkBU;EACE,4BAAA;AAhBZ;AAmBU;EACE,+CAAA;EACA,YAAA;EACA,eAAA;AAjBZ;AAoBU;EACE,yBAAA;AAlBZ;AAqBU;EACE,0BAAA;AAnBZ;AAuBQ;EACE,iBAAA;EACA,mBAAA;EACA,uBAAA;AArBV;AA0BI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAxBN;AA0BM;EACE,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AAxBR;AA0BQ;EACE,aAAA;EACA,cAAA;EACA,4BAAA;EACA,qBAAA;EACA,cAAA;AAxBV;AA4BM;EACE,iBAAA;EACA,qBAAA;AA1BR;;AAgCA;EACE,gBAAA;AA7BF","sourcesContent":[".table-wrap {\n  background: var(--white);\n  padding: 3rem 2rem 4rem;\n  border-radius: 0.8rem;\n  display: grid;\n\n  & > .header {\n    margin-bottom: 2rem;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: 4rem;\n    align-items: center;\n\n    & > div:nth-child(even) {\n      justify-self: flex-end;\n    }\n\n    & > .title {\n      font-size: 2rem;\n      line-height: 2.4rem;\n      color: var(--black);\n      padding-left: 1rem;\n    }\n\n    & .exports {\n      display: flex;\n      gap: 1rem;\n\n      & .btn {\n        position: relative;\n\n        & .title {\n          display: none;\n          font-size: 1.2rem;\n          line-height: 1.4rem;\n          color: var(--white);\n          white-space: nowrap;\n          background: var(--grey-icon);\n          padding: 0.5rem 1rem;\n          border-radius: 0.4rem;\n          position: absolute;\n          bottom: 0;\n          left: 50%;\n          transform: translate(-50%, 100%);\n        }\n\n        & i {\n          font-size: 2.4rem;\n          cursor: pointer;\n\n          &:before {\n            color: var(--grey-icon);\n            transition: color 0.3s;\n          }\n        }\n\n        &:hover {\n          & .title {\n            display: block;\n          }\n\n          & i:before {\n            color: var(--primary);\n          }\n        }\n      }\n    }\n\n    & .nav {\n      display: flex;\n      align-items: center;\n      gap: 4rem;\n\n      & .tabs {\n        display: flex;\n        gap: 1rem;\n\n        & .tab {\n          height: 2.4rem;\n          font-size: 1.2rem;\n          line-height: 1.4rem;\n          color: var(--black);\n          background: var(--bg);\n          padding: 0 1.5rem;\n          border-radius: 3rem;\n          display: flex;\n          align-items: center;\n          cursor: pointer;\n          transition:\n            color 0.2s,\n            background 0.2s;\n\n          &.active {\n            color: var(--white);\n            background: var(--primary);\n          }\n        }\n      }\n\n      & .pagination {\n        display: flex;\n        align-items: center;\n        gap: 1rem;\n\n        & .btn {\n          width: 2.4rem;\n          height: 2.4rem;\n          font-size: 1.2rem;\n          color: var(--grey);\n          border: 0.1rem solid var(--grey-variable-hover);\n          border-radius: 0.2rem;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          transition: border-color 0.2s;\n\n          &:hover {\n            border-color: var(--primary-30);\n          }\n\n          &:active {\n            border-color: var(--primary);\n          }\n\n          &:disabled {\n            border: 0.1rem solid var(--grey-variable-hover);\n            opacity: 0.5;\n            cursor: default;\n          }\n\n          &.prev {\n            transform: rotateZ(90deg);\n          }\n\n          &.next {\n            transform: rotateZ(-90deg);\n          }\n        }\n\n        & .current {\n          font-size: 1.2rem;\n          line-height: 1.4rem;\n          color: var(--grey-icon);\n        }\n      }\n    }\n\n    & .action {\n      display: flex;\n      align-items: center;\n      gap: 3rem;\n\n      & .currency {\n        font-size: 1.2rem;\n        line-height: 1.4rem;\n        color: var(--grey-icon);\n        display: flex;\n        align-items: center;\n\n        & .divider {\n          width: 0.1rem;\n          height: 1.4rem;\n          background: var(--grey-icon);\n          display: inline-block;\n          margin: 0 1rem;\n        }\n      }\n\n      & .add {\n        font-size: 2.4rem;\n        color: var(--primary);\n      }\n    }\n  }\n}\n\n.scroll {\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
